import React, { useMemo } from 'react';
import classNames from 'classnames';
import useTranslation from '~/app/hooks/useTranslation';
import Icon from '~/app/common/Icon';
import { WorkOrderDetail } from '~/workorder/types';
import {
    formatWorkOrderDetailDate,
    formatWorkOrderDetailDateRange,
} from '~/workorder/helper';
import classes from './style.module.scss';
import { route } from '~/app/helpers/route';
import LinkWrapper from '~/app/common/LinkWrapper';
import { MACHINES_DETAILS_ROUTES } from '~/machines/Details/Router';

export type MainContentComponent = React.FC<{ data: WorkOrderDetail }>

const MainContent: MainContentComponent = ({ data }) => {
    const { t } = useTranslation('workorder');

    const statusClass = `status-${data.status}`;

    const plannedRange = useMemo(
        () => formatWorkOrderDetailDateRange(data.scheduledStartDate, data.scheduledEndDate),
        [data.scheduledStartDate, data.scheduledEndDate],
    );

    const workStarted = useMemo(
        () => formatWorkOrderDetailDate(data.actualStartDate),
        [data.actualStartDate],
    );

    const workFinished = useMemo(
        () => formatWorkOrderDetailDate(data.actualEndDate),
        [data.actualEndDate],
    );

    const responsibleName = data.personnel?.name?.trim();

    return (
        <div className={classes['card']}>
            <div className={classes['header']}>
                <div className={classes['header-main']}>
                    <div className={classes['title-row']}>
                        <h1 className={classes['title']}>{data.excavator?.name}</h1>
                        <LinkWrapper to={route(MACHINES_DETAILS_ROUTES.details, { projectId: data.projectId ?? 0, id: data.excavator.id })} className={classes['launch-link']}>
                            <Icon name="launch" size={18} className={classes['launch-icon']} />
                        </LinkWrapper>
                    </div>
                    {data.excavator?.intern && (
                        <p className={classes['intern']}>{data.excavator.intern}</p>
                    )}
                </div>
                <span className={classNames(classes['status'], classes[statusClass])}>
                    {t(`statuses.${data.status}`)}
                </span>
            </div>

            <div className={classes['details']}>
                {responsibleName && (
                    <div className={classes['row']}>
                        <span className={classes['label']}>{t('detail.responsible')}</span>
                        <span className={classes['value']}>{responsibleName}</span>
                    </div>
                )}
                <div className={classes['row']}>
                    <span className={classes['label']}>{t('detail.employee')}</span>
                    <div className={classes['employee-value']}>
                        {data.mechanics?.map(mechanic => (
                            <span key={mechanic.id} className={classes['chip']}>
                                {mechanic.name}
                            </span>
                        ))}
                        {false && <span className={classes['add-chip']} aria-hidden>
                            <Icon name="add" size={16} />
                        </span>}
                    </div>
                </div>
                <div className={classes['row']}>
                    <span className={classes['label']}>{t('detail.planned')}</span>
                    <span className={classes['value']}>{plannedRange ?? '-'}</span>
                </div>
                <div className={classes['row']}>
                    <span className={classes['label']}>{t('detail.workStarted')}</span>
                    <span className={classes['value']}>{workStarted ?? '-'}</span>
                </div>
                <div className={classes['row']}>
                    <span className={classes['label']}>{t('detail.workFinished')}</span>
                    <span className={classes['value']}>{workFinished ?? '-'}</span>
                </div>
            </div>

            <div className={classes['footer']}>
                {data.workOrderNo}
            </div>
        </div>
    );
};

export default MainContent;